import { Injectable } from '@angular/core';
import { CustomHttp, ApiConstants } from '../../shared';

@Injectable()
export class AddToAccountModalService {
    constructor(private customHttp: CustomHttp, private apiConstants: ApiConstants) {}

    public getAccounts() {
        return new Promise((resolve, reject) => {
            this.apiConstants.getAccounts(this.customHttp)
            .then((accounts) => {
                resolve(accounts);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/catalogue/add-to-acount-modal/add-to-account-modal.service.ts